import React from "react";
import { CircleAlert, TriangleAlert } from "lucide-react";

export type ErrorBannerType =
  | "out_of_stock"
  | "not_available_in_country"
  | "default";

interface ErrorBannerProps {
  type: ErrorBannerType;
  className?: string;
  message?: string;
}

const errorConfig = {
  out_of_stock: {
    bg: "bg-red-50",
    border: "border-red-200",
    text: "text-red-700",
    icon: <CircleAlert className="mr-2 h-5 w-5 flex-shrink-0 text-red-500" />,
    message: "Out of Stock",
  },
  not_available_in_country: {
    bg: "bg-yellow-50",
    border: "border-yellow-200",
    text: "text-yellow-800",
    icon: (
      <TriangleAlert className="mr-2 h-5 w-5 flex-shrink-0 text-yellow-500" />
    ),
    message: "Not Available in Your Country",
  },
  default: {
    bg: "bg-gray-50",
    border: "border-gray-200",
    text: "text-gray-700",
    icon: <CircleAlert className="mr-2 h-5 w-5 flex-shrink-0 text-gray-500" />,
    message: "Something went wrong with this item",
  },
} as const;

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  type,
  className = "",
  message,
}) => {
  const config = errorConfig[type];
  return (
    <div
      className={`mb-2 flex items-center rounded-sm border-l-4 ${config.bg} ${config.border} ${config.text} px-4 py-3 text-sm font-medium ${className}`}
      role="alert"
    >
      {config.icon}
      <span>{message ?? config.message}</span>
    </div>
  );
};

export default ErrorBanner;
